module.exports = __webpack_public_path__ + "e02f3f93b8ecc8bd9cec80b11f7e7cbf.pdf";